import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import FormSpinner from '../common/utility/FormSpinner';
import { userAccountConstants, userAccountContentConstants, userAccountFormConstants } from '../utils/user-account-constants';
import * as formStateHelpers from '../forms/helpers/form-helpers/form-state-helper';
import * as userAccountActions from '../../store/actions/user-account-actions';
import * as apiResponseMessages from '../../store/actions/api-response-messages';

import * as signInFormActions from '../../store/actions/sign-in-form-actions';
import { isEmpty } from '../utils/obj-utils';
import AccountMenu from './AccountMenu';
import { formMessageConstants } from '../utils/constants/form-message-constants';
import { domainConstants } from '../utils/constants/domain-constants';
import userService from '../../../../general/js/user/user-service';
import { hasValue, isRefMounted } from '../../../../general/js/general-helpers';
import ModalTriggerPromoPanelComponent from '../../../modal-trigger-promo-panel/js/modal-trigger-promo-panel.component';
import {
    getInitials,
    getParameterByName,
    getTitleLabel,
    removeParameterByName
} from '../../../../general/js/utils';
import withLoadingInterval from '../hocComponents';
import { USER_STATE_VALID } from '../../../../general/js/user/constants';

class UserAccountPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAccountData: {},
            shouldDisplayMenu: false,
            componentToRender: userAccountContentConstants.accountHomePage,
            fileNumberForDisplay: 0,
            upcomingTicket: {}
        };

        this.modalTriggerPromoPanelRef = React.createRef();
        this.modalTrigger = null;
        this.updateUserAccountData = this.updateUserAccountData.bind(this);
        this.updateComponentToRenderDisplay = this.updateComponentToRenderDisplay.bind(this);
        this.updateComponentToRender = this.updateComponentToRender.bind(this);
        this.displayMyAccountPage = this.displayMyAccountPage.bind(this);
        this.handleChangeAccountDetailsContent = this.handleChangeAccountDetailsContent.bind(this);
        this.handleViewFileSummaryClick = this.handleViewFileSummaryClick.bind(this);
        this.handleViewTicketsClick = this.handleViewTicketsClick.bind(this);
        this.displayAccountDetailsContent = this.displayAccountDetailsContent.bind(this);
        this.refreshAccountPage = this.refreshAccountPage.bind(this);
        this.toggleDisplayMenu = this.toggleDisplayMenu.bind(this);
    }

    componentDidMount() {
        this.refreshAccountPage(true);
    }

    componentDidUpdate() {
        if (!hasValue(this.modalTrigger)) {
            const refMounted = isRefMounted(this.modalTriggerPromoPanelRef);
            this.modalTrigger = refMounted ?
                new ModalTriggerPromoPanelComponent(this.modalTriggerPromoPanelRef.current, 'modal-trigger-promo-panel') :
                null;
        } else if (!isRefMounted(this.modalTriggerPromoPanelRef)) {
            this.modalTrigger.destroy();
        }
    }

    componentWillUnmount() {
        if (hasValue(this.modalTrigger)) {
            this.modalTrigger.destroy();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            isUserAccountDataLoadedSuccessful,
            isAccountPageRefresh,
            userAccountData
        } = nextProps;

        if (isUserAccountDataLoadedSuccessful &&
            !isEmpty(userAccountData)) {
            this.updateUserAccountData(userAccountData);

            if (isAccountPageRefresh) {
                this.updateComponentToRenderDisplay();
            }
        }
    }

    updateComponentToRenderDisplay() {
        let componentToRender = getParameterByName('componentToRender');
        const { ssoDomain } = this.props.accountFormData;

        if (isEmpty(componentToRender)) {
            return;
        }

        if (componentToRender === userAccountContentConstants.theOneClub &&
            ssoDomain === domainConstants.womensOpen) {
            componentToRender = userAccountContentConstants.accountHomePage;
        }

        this.updateComponentToRender(componentToRender);

        removeParameterByName('componentToRender');
    }

    updateUserAccountData(nextUserAccountData) {
        const { accountFormData, actions } = this.props;

        if (isEmpty(accountFormData) || isEmpty(nextUserAccountData)) {
            actions.signOutUser();
            return;
        }

        const userAccountData = _.cloneDeep(nextUserAccountData);
        userAccountData.titleLabel = getTitleLabel(userAccountData.title, accountFormData.ssoUserDetailsFields.title.options);
        userAccountData.initials = getInitials(userAccountData.firstName, userAccountData.lastName);

        const isOneClubMember = userAccountData.membership.includes(userAccountConstants.oneClub);
        userAccountData.isOneClubMember = isOneClubMember;

        userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(userAccountData.membership));
        const customEvent = new CustomEvent('tochDataChanged', { detail: { showOneClubHubLink: isOneClubMember, membership: userAccountData.membership } });
        document.dispatchEvent(customEvent);

        this.setState(
            (prevState) => ({
                ...prevState,
                userAccountData
            })
        );
    }

    handleChangeAccountDetailsContent(event, nexComponentToRender) {
        if (event !== null) {
            event.preventDefault();
        }

        this.updateComponentToRender(nexComponentToRender);
    }

    updateComponentToRender(componentToRender, callbackFunction) {
        this.setState(
            (state) => ({
                ...state,
                componentToRender,
                fileNumberForDisplay: 0,
                upcomingTicket: {}
            }), callbackFunction
        );
    }

    refreshAccountPage(shouldRefreshComponent) {
        const { actions, accountFormData } = this.props;
        if (isEmpty(accountFormData)) {
            actions.signOutUser();
            return;
        }

        const { getUserDataCallbackUrl } = accountFormData;
        actions.getUserAccountData(getUserDataCallbackUrl, shouldRefreshComponent);
    }

    handleViewFileSummaryClick(fileNumber) {
        this.setState(
            (state) => ({
                ...state,
                componentToRender: userAccountContentConstants.userOrderHistory,
                fileNumberForDisplay: fileNumber
            })
        );
    }

    handleViewTicketsClick(upcomingTicket) {
        this.setState(
            (state) => ({
                ...state,
                componentToRender: userAccountContentConstants.userTickets,
                upcomingTicket
            })
        );
    }

    toggleDisplayMenu() {
        this.setState(formStateHelpers.toggleKey('shouldDisplayMenu'));
    }

    displayMyAccountPage() {
        const {
            componentToRender, userAccountData, shouldDisplayMenu
        } = this.state;
        const {
            accountFormData, isUserAccountDataLoadedSuccessful,
            isUserNotSignedIn, elapsedTime
        } = this.props;
        const { ssoDomain } = accountFormData;
        const { ssoAccountHomePageFields } = accountFormData;
        const {
            modalTriggerPromoPanel,
            serverErrorMessage,
            loadingErrorMessage,
            elapsedTimeLimit,
        } = ssoAccountHomePageFields;
        const { displayResaleTicketsMenuItem } = accountFormData;
        const dataLoadedSuccessful = !isUserNotSignedIn && isUserAccountDataLoadedSuccessful && !isEmpty(userAccountData);

        if (isUserNotSignedIn) {
            userService.removeDataFromLocalStorage(USER_STATE_VALID);
            if (serverErrorMessage && isUserNotSignedIn
                .includes(apiResponseMessages.SERVER_ERROR_MESSAGE)) {
                return <div className='error-message'>
                    <p>{serverErrorMessage}</p>
                </div>;
            }

            return (
                <div
                    data-dc-component='modal-trigger-promo-panel'
                    data-dc-modal-trigger-promo-panel-options={JSON.stringify(modalTriggerPromoPanel)}
                    ref={this.modalTriggerPromoPanelRef}>
                </div>
            );
        }

        if (isEmpty(userAccountData)) {
            if (elapsedTime > elapsedTimeLimit && loadingErrorMessage) {
                return <React.Fragment>
                    <div className='error-message'>
                        <p>{loadingErrorMessage}</p>
                    </div>
                    <FormSpinner/>
                </React.Fragment>;
            }
            return <FormSpinner/>;
        }

        return (<div className='menu-body'>
            {dataLoadedSuccessful && <AccountMenu
                userAccountData={userAccountData}
                accountFormData={accountFormData}
                ssoDomain={ssoDomain}
                displayResaleTicketsMenuItem={displayResaleTicketsMenuItem}
                shouldDisplayMenu={shouldDisplayMenu}
                componentToRender={componentToRender}
                handleChangeAccountDetailsContent={this.handleChangeAccountDetailsContent}
                toggleDisplayMenu={this.toggleDisplayMenu}></AccountMenu>}
            <div className='content'>
                {dataLoadedSuccessful && this.displayAccountDetailsContent()}
            </div>
        </div>
        );
    }

    displayAccountDetailsContent() {
        const {
            componentToRender,
            userAccountData,
            fileNumberForDisplay,
            upcomingTicket
        } = this.state;
        const { accountFormData } = this.props;
        if (isEmpty(userAccountFormConstants[componentToRender])) {
            return <h1>{formMessageConstants.somethingWentWrong}</h1>;
        }

        const copyOfAccountFormData = _.cloneDeep(accountFormData);
        const copyOfUserAccountData = _.cloneDeep(userAccountData);

        return userAccountFormConstants[componentToRender]({
            accountFormData: copyOfAccountFormData,
            userAccountData: copyOfUserAccountData,
            fileNumberForDisplay,
            upcomingTicket,
            refreshAccountPage: this.refreshAccountPage,
            handleViewFileSummaryClick: this.handleViewFileSummaryClick,
            handleViewTicketsClick: this.handleViewTicketsClick
        });
    }

    render() {
        return this.displayMyAccountPage();
    }
}

UserAccountPage.propTypes = {
    accountFormData: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        isUserNotSignedIn: state.userAccount.isUserNotSignedIn,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
        isAccountPageRefresh: state.userAccount.isAccountPageRefresh,
        userAccountData: state.userAccount.userAccountData,
        loadHomePageTicketsDataErrorMessages: state.userAccount.loadHomePageTicketsDataErrorMessages,
        loading: state.apiStatus.apiCallsInProgress > 0,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch),
            signOutUser: bindActionCreators(signInFormActions.signOutUser, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withLoadingInterval(UserAccountPage));
